const proxy = '/api'

// 消息持续多长时间后消失
export const durationTime = 3000

// 中文语言默认的字符串
export const languageZh = 'zh_CN'

// 英文语言默认的字符串
export const languageEn = 'en_US'

// sessionStorage中存储的对象名称
export const sessionName = 'hwm_session'

// 质量表格提交
export const QualityUpLoad = proxy + '/backClass/QualityUpLoad.ashx?type=QualityUpLoadExcel'



// WEBPACK FOOTER //
// ./src/utils/const.js